import { Component, OnInit, HostListener } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AuthenticationService } from '../../services/auth/authentication.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

  active : any = "";
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    public authService: AuthenticationService,
  ) { }

  // a group heading (e.g. "Berlangganan") only needs to hide when NONE of its
  // items are reachable — Super Admin passes everything via hasMenu()
  can(...menuKeys: string[]){
    return menuKeys.some(k => this.authService.hasMenu(k));
  }

  ngOnInit(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
    ).subscribe(() => {
      this.closeMobile(); // navigating away always closes the mobile drawer
      this.flyout = null;
      const rt = this.getChild(this.activatedRoute);
      rt.data.subscribe(data => {
        this.titleService.setTitle(data.title);
        this.active = data.menu;
      });
    });
  }

  // rail state — drives the icon tooltips
  get mini(): boolean {
    return document.body.classList.contains('minimenu');
  }

  closeMobile() {
    document.body.classList.remove('mobile-nav-open');
  }

  // rail mode: a group click opens a small flyout beside the rail with its
  // children — the sidebar stays collapsed, nothing is auto-selected
  flyout: any = null;
  private flyGroups: any = {
    konten: {label: 'Konten', items: [
      {path: '/content-feed', label: 'Feed', key: 'contentFeed'},
      {path: '/content-video', label: 'Video', key: 'contentVideo'},
    ]},
    voucher: {label: 'Voucher', items: [
      {path: '/voucher-list', label: 'List', key: 'voucherList'},
      {path: '/voucher-background', label: 'Background', key: 'voucherBackground'},
    ]},
    langganan: {label: 'Berlangganan', items: [
      {path: '/subscribe-voucher', label: 'Voucher', key: 'subscribeVoucher'},
      {path: '/subscribe-store', label: 'Store', key: 'subscribeStore'},
    ]},
  };

  onGroup(event: any, key: string) {
    if (!this.mini) { return; } // full sidebar: submenus are already visible
    event.stopPropagation();
    if (this.flyout && this.flyout.key === key) {
      this.flyout = null;
      return;
    }
    const rect = event.currentTarget.getBoundingClientRect();
    this.flyout = {
      key: key,
      top: Math.min(rect.top, window.innerHeight - 140), // keep it on-screen
      ...this.flyGroups[key],
    };
  }

  @HostListener('document:click')
  @HostListener('document:keydown.escape')
  closeFlyout() {
    this.flyout = null;
  }

  get title(): string { return this.titleService.getTitle() }
  getChild(activatedRoute: ActivatedRoute) {  
    if (activatedRoute.firstChild) {  
      return this.getChild(activatedRoute.firstChild);  
    } else {  
      return activatedRoute;  
    }  
  }

}
